var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-way-list"},[_c('contact-way',{attrs:{"type":"Facebook","dir":"left"}}),_vm._v(" "),_c('contact-way',{attrs:{"type":"WhatsApp","dir":"center"}}),_vm._v(" "),_c('contact-way',{attrs:{"type":"Telegram","dir":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }